import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../context/store";
import { functions } from "../constants/common-functions";
import { useHistory } from "react-router-dom";
import Header from "../components/Header";
import LeftMenu from "../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GREY_BACKGROUND } from "../constants/general-constants";

import { useGoogleMaps } from "react-hook-google-maps";
import { GOOGLE_MAPS_KEY } from "../constants/general-constants";

import bluepin from "../../images/bluepin.png";
import darkbluepin from "../../images/darkbluepin.png";
import orangepin from "../../images/orangepin.png";
import redpin from "../../images/redpin.png";
import purplepin from "../../images/purplepin.png";
import blackpin from "../../images/blackpin.png";
import yellowpin from "../../images/yellowpin.png";

import MapPinHoverPopUp from "../components/MapPinHoverPopUp";
import MapKey from "../components/MapKey";
import MapList from "../components/MapList";
import DashboardChoicePanel from "../components/DashboardChoicePanel";

import { JWT } from "../constants/local-storage";

export default function Map({ facilityTypeMaps, locations, isMobile }) {
	
	window.closeInfoWindow = () => {
	  if (infoWindowRef.current) {
	    infoWindowRef.current.close();
	  }
	};	
	
  const globalState = useContext(store);
  const history = useHistory();

  const [keyDisplay, setKeyDisplay] = useState(true);
  const [listDisplay, setListDisplay] = useState(false);
  const [selectedFacilityTypeMapId, setSelectedFacilityTypeMapId] = useState("-100");
  const [displayLocations, setDisplayLocations] = useState([]);

  const [dashboardChoiceDisplay, setDashboardChoiceDisplay] = useState("none");
  const [facilityId, setFacilityId] = useState(null);
  
  const [popUpLeft, setPopUpLeft] = useState("0px");
  const [popUpTop, setPopUpTop] = useState("0px");
  const [popUpDisplay, setPopUpDisplay] = useState("none");
  const [popUpTitle, setPopUpTitle] = useState("");
  const [popUpDescription, setPopUpDescription] = useState("");

  const infoWindowRef = useRef(null);

  const { ref, map, google } = useGoogleMaps(GOOGLE_MAPS_KEY, {
    center: { lat: 0, lng: 0 },
    zoom: 3,
    mapTypeId: "roadmap"
  });

  // =====================================================
  // MAP PIN RESOLUTION
  // =====================================================

  const getMapPin = (facilityTypeMapId) => {
    let returnPin = blackpin;

    for (let i = 0; i < facilityTypeMaps.length; i++) {
      if (facilityTypeMaps[i].id === facilityTypeMapId) {
        switch (facilityTypeMaps[i].icon) {
          case "bluepin": return bluepin;
          case "darkbluepin": return darkbluepin;
          case "orangepin": return orangepin;
          case "redpin": return redpin;
          case "purplepin": return purplepin;
          case "yellowpin": return yellowpin;
          default: return blackpin;
        }
      }
    }
    return returnPin;
  };

  // =====================================================
  // FILTER LOCATIONS
  // =====================================================

  useEffect(() => {
    if (selectedFacilityTypeMapId === "-100") {
      setDisplayLocations(locations);
    } else {
      setDisplayLocations(
        locations.filter(l => l.facilityTypeMapId === selectedFacilityTypeMapId)
      );
    }
  }, [locations, selectedFacilityTypeMapId]);

  // =====================================================
  // INFO WINDOW CONTENT
  // =====================================================

  const getInfoWindowContent =
      (loc) =>
      {
          //----------------------------------------------------
          // Mobile
          //----------------------------------------------------

          if(isMobile)
          {
              return `

                  <div style="
                      width:260px;

                      background:
                          linear-gradient(
                              135deg,
                              #292d31 0%,
                              #1b1f22 52%,
                              #0d0f11 100%
                          );

                      border:
                          1px solid
                          rgba(255,255,255,0.10);

                      border-bottom:
                          2px solid
                          rgba(69,175,224,0.70);

                      box-shadow:
                          0 10px 28px
                          rgba(0,0,0,0.30);

                      position:relative;

                      box-sizing:border-box;

                      overflow:hidden;
                  ">

                      <!-- =====================================
                           CLOSE
                      ====================================== -->

                      <div
                          style="
                              position:absolute;
                              top:8px;
                              right:8px;

                              width:28px;
                              height:28px;

                              display:flex;
                              align-items:center;
                              justify-content:center;

                              color:white;

                              font-size:14px;
                              font-weight:600;

                              cursor:pointer;

                              background:
                                  rgba(0,0,0,0.30);

                              border:
                                  1px solid
                                  rgba(255,255,255,0.18);

                              z-index:10;
                          "

                          onclick="window.closeInfoWindow()"
                      >

                          ✕

                      </div>


                      <!-- =====================================
                           PHOTO
                      ====================================== -->

                      <div style="
                          width:100%;
                          height:115px;

                          display:flex;
                          align-items:center;
                          justify-content:center;

                          overflow:hidden;

                          background:
                              rgba(0,0,0,0.12);

                          border-bottom:
                              1px solid
                              rgba(255,255,255,0.10);
                      ">

                          <div
                              class="popup-nophoto"

                              style="
                                  font-size:12px;

                                  color:
                                      rgba(255,255,255,0.58);

                                  width:100%;
                                  height:100%;

                                  display:flex;
                                  align-items:center;
                                  justify-content:center;

                                  text-align:center;

                                  box-sizing:border-box;
                              "
                          >

                              No photo available

                          </div>

                          <img
                              class="popup-photo"

                              style="
                                  display:none;

                                  width:100%;
                                  height:115px;

                                  object-fit:cover;
                              "
                          />

                      </div>


                      <!-- =====================================
                           CONTENT
                      ====================================== -->

                      <div style="
                          padding:12px 14px 14px 14px;
                      ">

                          <div style="
                              font-size:15px;
                              font-weight:650;

                              color:#ffffff;

                              padding-bottom:8px;
                              margin-bottom:8px;

                              border-bottom:
                                  1px solid
                                  rgba(255,255,255,0.10);
                          ">

                              ${loc.name}

                          </div>


                          <div style="
                              font-size:11px;

                              color:
                                  rgba(255,255,255,0.68);

                              line-height:15px;

                              margin-bottom:12px;
                          ">

                              ${loc.description || ""}

                          </div>


                          <!-- =================================
                               ACTIONS
                          ================================== -->

                          <div style="
                              display:flex;
                              gap:1px;

                              background:
                                  rgba(255,255,255,0.12);
                          ">

                              <div
                                  style="
                                      flex:1;

                                      height:38px;

                                      background:
                                          linear-gradient(
                                              180deg,
                                              #45afe0 0%,
                                              #2695cc 100%
                                          );

                                      color:white;

                                      display:flex;
                                      align-items:center;
                                      justify-content:center;

                                      cursor:pointer;

                                      font-size:11px;
                                      font-weight:600;

                                      box-shadow:
                                          inset 0 1px 0
                                          rgba(255,255,255,0.22);
                                  "

                                  onclick="
                                      window.location=
                                      '/facility/${loc.id}'
                                  "
                              >

                                  View Details

                              </div>


                              <div
                                  style="
                                      flex:1;

                                      height:38px;

                                      background:
                                          linear-gradient(
                                              180deg,
                                              #45afe0 0%,
                                              #2695cc 100%
                                          );

                                      color:white;

                                      display:flex;
                                      align-items:center;
                                      justify-content:center;

                                      cursor:pointer;

                                      font-size:11px;
                                      font-weight:600;

                                      box-shadow:
                                          inset 0 1px 0
                                          rgba(255,255,255,0.22);
                                  "

                                  onclick="
                                      window.handleDashboardClick(
                                          ${loc.id}
                                      )
                                  "
                              >

                                  Dashboards

                              </div>

                          </div>

                      </div>

                  </div>

              `;
          }


          //----------------------------------------------------
          // Desktop
          //----------------------------------------------------

          return `

              <div style="
                  display:flex;

                  width:600px;

                  min-height:180px;

                  background:
                      linear-gradient(
                          135deg,
                          #292d31 0%,
                          #1b1f22 52%,
                          #0d0f11 100%
                      );

                  border:
                      1px solid
                      rgba(255,255,255,0.10);

                  border-bottom:
                      2px solid
                      rgba(69,175,224,0.70);

                  box-shadow:
                      0 12px 32px
                      rgba(0,0,0,0.32);

                  position:relative;

                  overflow:hidden;
              ">


                  <!-- =========================================
                       CLOSE
                  ========================================== -->

                  <div
                      style="
                          position:absolute;

                          top:10px;
                          right:10px;

                          width:30px;
                          height:30px;

                          display:flex;
                          align-items:center;
                          justify-content:center;

                          color:white;

                          font-size:15px;
                          font-weight:600;

                          cursor:pointer;

                          background:
                              rgba(0,0,0,0.30);

                          border:
                              1px solid
                              rgba(255,255,255,0.18);

                          z-index:10;
                      "

                      onclick="window.closeInfoWindow()"
                  >

                      ✕

                  </div>


                  <!-- =========================================
                       PHOTO
                  ========================================== -->

                  <div style="
                      width:240px;
                      min-width:240px;

                      height:180px;

                      display:flex;
                      align-items:center;
                      justify-content:center;

                      overflow:hidden;

                      background:
                          rgba(0,0,0,0.14);

                      border-right:
                          1px solid
                          rgba(255,255,255,0.10);
                  ">

                      <div
                          class="popup-nophoto"

                          style="
                              font-size:13px;

                              color:
                                  rgba(255,255,255,0.58);

                              width:100%;
                              height:100%;

                              display:flex;
                              align-items:center;
                              justify-content:center;

                              text-align:center;
                          "
                      >

                          No photo available

                      </div>


                      <img
                          class="popup-photo"

                          style="
                              display:none;

                              width:240px;
                              height:180px;

                              object-fit:cover;
                          "
                      />

                  </div>


                  <!-- =========================================
                       INFORMATION
                  ========================================== -->

                  <div style="
                      width:360px;

                      box-sizing:border-box;

                      padding:18px 20px;

                      display:flex;

                      flex-direction:column;
                  ">

                      <div style="
                          font-size:18px;

                          font-weight:650;

                          color:#ffffff;

                          padding-right:30px;

                          padding-bottom:9px;

                          margin-bottom:9px;

                          border-bottom:
                              1px solid
                              rgba(255,255,255,0.10);
                      ">

                          ${loc.name}

                      </div>


                      <div style="
                          font-size:12px;

                          color:
                              rgba(255,255,255,0.68);

                          line-height:17px;

                          flex-grow:1;
                      ">

                          ${loc.description || ""}

                      </div>


                      <!-- =====================================
                           ACTIONS
                      ====================================== -->

                      <div style="
                          display:flex;

                          gap:1px;

                          margin-top:14px;

                          background:
                              rgba(255,255,255,0.12);
                      ">

                          <div
                              style="
                                  flex:1;

                                  height:38px;

                                  background:
                                      linear-gradient(
                                          180deg,
                                          #45afe0 0%,
                                          #2695cc 100%
                                      );

                                  color:white;

                                  display:flex;

                                  align-items:center;

                                  justify-content:center;

                                  cursor:pointer;

                                  font-size:12px;

                                  font-weight:600;

                                  box-shadow:
                                      inset 0 1px 0
                                      rgba(255,255,255,0.22);
                              "

                              onclick="
                                  window.location=
                                  '/facility/${loc.id}'
                              "
                          >

                              View Details

                          </div>


                          <div
                              style="
                                  flex:1;

                                  height:38px;

                                  background:
                                      linear-gradient(
                                          180deg,
                                          #45afe0 0%,
                                          #2695cc 100%
                                      );

                                  color:white;

                                  display:flex;

                                  align-items:center;

                                  justify-content:center;

                                  cursor:pointer;

                                  font-size:12px;

                                  font-weight:600;

                                  box-shadow:
                                      inset 0 1px 0
                                      rgba(255,255,255,0.22);
                              "

                              onclick="
                                  window.handleDashboardClick(
                                      ${loc.id}
                                  )
                              "
                          >

                              Dashboards

                          </div>

                      </div>

                  </div>

              </div>

          `;
      };

  // =====================================================
  // PHOTO LOADER (ONLY ON CLICK)
  // =====================================================

  const loadPopupPhoto = (loc) => {
    if (!loc.photoFile) return;

    const img = document.querySelector(".popup-photo");
    const txt = document.querySelector(".popup-nophoto");

    if (!img || !txt) return;

    const imageUrl =
      globalState.state.client.resourceFolderUrl +
      "/buildingphotos/" +
      loc.code +
      "/" +
      loc.photoFile;

    fetch(imageUrl, {
      //headers: { Authorization: localStorage.getItem(JWT) }
    })
      .then(r => r.blob())
      .then(blob => {
        if (blob.size > 1000) {
          img.src = URL.createObjectURL(blob);
          img.style.display = "block";
          txt.style.display = "none";
        }
      });
  };

  // =====================================================
  // MARKERS
  // =====================================================

  useEffect(() => {
    if (!map || !google) return;

    if (!infoWindowRef.current) {
      infoWindowRef.current = new google.maps.InfoWindow();
    }

    const bounds = new google.maps.LatLngBounds();

    displayLocations.forEach(loc => {
      if (isNaN(loc.lat) || isNaN(loc.lng)) return;

      const position = { lat: +loc.lat, lng: +loc.lng };
      bounds.extend(position);

      const marker = new google.maps.Marker({
        position,
        map,
        icon: {
          url: getMapPin(loc.facilityTypeMapId),
          scaledSize: new google.maps.Size(29, 40),
          anchor: new google.maps.Point(14, 40)
        }
      });

      marker.addListener("click", () => {
        infoWindowRef.current.setContent(getInfoWindowContent(loc));
        infoWindowRef.current.open(map, marker);
        setTimeout(() => loadPopupPhoto(loc), 50);
      });
	  
	  marker.addListener("mouseover", (e) => {
	    setPopUpTitle(loc.name);
	    setPopUpDescription(loc.description);
	    setPopUpDisplay("flex");
	    setPopUpLeft(e.domEvent.clientX - 100 + "px");
	    setPopUpTop(e.domEvent.clientY + 30 + "px");
	  });

	  marker.addListener("mouseout", () => {
	    setPopUpDisplay("none");
	  });
    });

    map.fitBounds(bounds);
  }, [map, google, displayLocations]);

  // =====================================================
  // UI
  // =====================================================

  return (
   <>
        <div ref={ref} style={{ width: "100%", height: "100%" }} />
     

      <MapKey
        keyDisplay={keyDisplay}
        setKeyDisplay={setKeyDisplay}
        selectedFacilityTypeMapId={selectedFacilityTypeMapId}
        setSelectedFacilityTypeMapId={setSelectedFacilityTypeMapId}
		isMobile={isMobile}
      />

      <MapList listDisplay={listDisplay} setListDisplay={setListDisplay} />

      <DashboardChoicePanel
        display={dashboardChoiceDisplay}
        facilityId={facilityId}
        setDisplay={setDashboardChoiceDisplay}
      />
	  
	  
	  <MapPinHoverPopUp
	    title={popUpTitle}
	    description={popUpDescription}
	    left={popUpLeft}
	    top={popUpTop}
	    display={popUpDisplay}
	  />
    </>
  );
}
